<script>
  import FlowBox2 from '../components/FlowBox2.svelte'
  import Tailwindcss from '../Tailwind.svelte'
  import {Loading} from 'carbon-components-svelte'
  import {Rive, Fit, Layout, Alignment} from "@rive-app/canvas"
  import "carbon-components-svelte/css/g90.css";
  import {itemC, container} from '../components/animations.js'
  import {location} from 'svelte-spa-router'
  import {Button} from 'carbon-components-svelte';
  import {_} from 'svelte-i18n'
  import Tailwind from '../Tailwind.svelte';
  import {M} from 'svelte-motion'
  import { sessionData } from '../stores';
  import { getAuth, RecaptchaVerifier} from 'firebase/auth';
  import {onMount} from 'svelte';

  let canvas;
  let innerWidth, innerHeight;
  export let rive


  function requestGeolocation() {
    $sessionData.hasGeolocated = true;
  }

  function checkOperatingsystem() {
    if(!$location.startsWith("/sumsub")){
      if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){ window.location.href = 'https://apps.apple.com/us/app/gambit-chess/id1606170280'; }
      if(navigator.userAgent.toLowerCase().indexOf("android") > -1){ window.location.href = 'https://play.google.com/store/apps/details?id=com.imgame.gambit&pli=1'; }
    }
  }

  onMount(async () => {
    requestGeolocation();

    if(!$location.startsWith("/sumsub")){
      checkOperatingsystem()
    }

    setTimeout(() => { innerWidth = window.innerWidth+1; }, 1)
    rive = new Rive({
      src: 'landinganim.riv',
      canvas: canvas, /* layout: new Layout({ fit: Fit.Contain, alignment: Alignment.Center }), */
      autoplay: true,
      layout: new Layout({ fit: Fit.Contain, alignment: Alignment.Center })
    });
  })

  $: if (innerWidth || innerHeight) {
    rive.layout = new Layout({ fit: Fit.Contain, alignment: Alignment.Center });
    /* rive.play('Hover'); */
  }
</script>

<svelte:window bind:innerWidth bind:innerHeight />
<Tailwind/>

{#if $sessionData.isAuthenticating}
  <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
    <div class="bg-black p-8 rounded-lg flex flex-col items-center gap-4">
      <Loading />
      <p class="text-white font-brown">Logging you in...</p>
    </div>
  </div>
{/if}
<div class={$sessionData.hasGeolocated ? 'interactable' : 'non-interactable'}>
  <div class="hidden-on-mobile overflow-hidden w-screen h-screen flex flex-row select-none">
    <FlowBox2/>
    <M.div variants={container} class="block w-1/2" >
      <canvas class="bg-black " height={innerHeight} width={innerWidth*0.5} bind:this={canvas}></canvas>
    </M.div>
  </div>
</div>

<style>
  .interactable {
    pointer-events: auto;
    opacity: 1;
  }

  .non-interactable {
    pointer-events: none;
    opacity: 0.5;
  }

  @media (max-width: 640px) {
    .hidden-on-mobile {
      display: none;
    }
  }

</style>
